import { Image, View } from 'react-native';
import { Button } from '@/components/ui/therapist/Button';
import { Icon } from '@/components/Icon';
import { Text } from '@/components/ui/therapist/Text';
import store from '@/stores/store';
import { useResponsiveHeight } from '@/components/Util/reactResponsiveDimensions';
import { IS_WEB } from '@/utils/platform';

import { styles } from './styles';
import colors from '@/config/colors';

export function NoPatient({
  handleAddPatient,
}: {
  handleAddPatient: () => void;
}) {
  const { user } = store.getState()?.signedInUser;
  return (
    <View style={styles.noPatientWrapper}>
      <Text
        style={[styles.welcomeTextMain, { fontSize: useResponsiveHeight(5) }]}
      >
        {user?.firstName ? `Hallo ${user?.firstName},` : 'Hallo!'}
      </Text>
      <Text
        style={[
          styles.welcomeTextSubMain,
          { fontSize: useResponsiveHeight(3) },
        ]}
      >
        willkommen bei neolexon
      </Text>
      <View style={styles.iconImageWrapper}>
        <View
          style={[
            styles.iconStyle,
            { top: '20%', left: IS_WEB ? '10%' : '4%' },
          ]}
        >
          <Icon
            name="addUser"
            size={useResponsiveHeight(5)}
            color={colors.newUI.therapist.blue50}
          />
        </View>
        <Image
          source={require('../../assets/welcome-woman.png')}
          style={{
            width: useResponsiveHeight(40),
            height: useResponsiveHeight(40),
          }}
          resizeMode="contain"
        />
      </View>
      <Text
        style={[styles.subTextMain, { fontSize: useResponsiveHeight(2.5) }]}
      >
        Lassen Sie uns starten!
      </Text>
      <Text
        style={[styles.subTextSubMain, { fontSize: useResponsiveHeight(2) }]}
      >
        Legen Sie Ihr erstes Patienten-Profil an
      </Text>
      <Button
        look="primary"
        icon={'addUser'}
        onPress={handleAddPatient}
        label="Patient:in hinzufügen "
      />
    </View>
  );
}
